export default (settings: any) => settings['eventHandlers'] * 0.5
